import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function NotConfirmed({ onClose }: ModalProps) {
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>인증 실패</S.ModalTitle>
        <S.ModalContent>
          <S.Summary>인증번호가 올바르지 않습니다.</S.Summary>
        </S.ModalContent>
        <S.CloseButton type="button" onClick={onClose}>
          확인
        </S.CloseButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
